import _ from 'lodash';
import urlParse from 'url-parse';

export function getPublisherByUrl(url, publishers = []) {
  if (!url) return null;
  const parsedUrl = urlParse(url);
  return _.find(publishers, p => p.publisherDomains && p.publisherDomains.some(d => d.includes(parsedUrl.hostname))) || null;
}
